import {useEffect, useState} from "react";
import {Table, Upload, Button, Image, message, Popconfirm} from "antd";
import {DeleteOutlined, UploadOutlined} from "@ant-design/icons";
import * as API_BOOKS from "../../../../../shared/http/books";
import {Book} from "../../../../../shared/types/api";
import Constants from "../../../../../const/Constants";

export const AdminCatalogBooks = () => {
    const [books, setBooks] = useState<Book[]>([]);
    const [loading, setLoading] = useState(false);
    const [uploading, setUploading] = useState(false);

    const fetchBooks = () => {
        setLoading(true);
        API_BOOKS.getCatalogBooks()
            .then((data) => setBooks(data || []))
            .catch(() => message.error("Ошибка загрузки каталога"))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchBooks();
    }, []);

    const handleUpload = async (info: any) => {
        setUploading(true);
        try {
            const resp = await API_BOOKS.uploadCatalogBook(info.file);
            if (resp.data) {
                setBooks((prev) => [...prev, resp.data]);
            }
            message.success("Книга добавлена в каталог");
        } catch (e) {
            message.error("Ошибка при загрузке книги");
        } finally {
            setUploading(false);
        }
    };

    const handleDelete = async (id: number) => {
        try {
            await API_BOOKS.deleteCatalogBook(id);
            setBooks((prev) => prev.filter((b) => b.id !== id));
            message.success("Книга удалена из каталога");
        } catch (e) {
            message.error("Ошибка при удалении");
        }
    };

    const columns = [
        {
            title: "Обложка",
            dataIndex: "coverId",
            key: "coverId",
            width: 80,
            render: (coverId: number) =>
                coverId ? (
                    <Image
                        src={`${Constants.queryConst}/v1/file/book/cover/image?id=${coverId}`}
                        width={50}
                        height={70}
                        style={{objectFit: "cover", borderRadius: 4}}
                    />
                ) : null,
        },
        {
            title: "Название",
            dataIndex: "title",
            key: "title",
        },
        {
            title: "Авторы",
            dataIndex: "authors",
            key: "authors",
            render: (authors: string[]) => authors?.join(", ") || "-",
        },
        {
            title: "Язык",
            dataIndex: "language",
            key: "language",
        },
        {
            title: "Действия",
            key: "actions",
            width: 100,
            render: (_: any, record: Book) => (
                <Popconfirm
                    title="Удалить книгу из каталога?"
                    onConfirm={() => handleDelete(record.id)}
                    okText="Да"
                    cancelText="Нет"
                >
                    <Button danger icon={<DeleteOutlined/>} size="small"/>
                </Popconfirm>
            ),
        },
    ];

    return (
        <div>
            <Upload
                name="file"
                accept=".epub"
                showUploadList={false}
                customRequest={handleUpload}
                disabled={uploading}
            >
                <Button
                    icon={<UploadOutlined/>}
                    loading={uploading}
                    disabled={uploading}
                    style={{marginBottom: 16}}
                >
                    {uploading ? "Загрузка..." : "Загрузить книгу в каталог (.epub)"}
                </Button>
            </Upload>

            <Table
                columns={columns}
                dataSource={books}
                rowKey="id"
                loading={loading}
                pagination={false}
            />
        </div>
    );
};